module.exports = __webpack_public_path__ + "img/left-top-font.9bd383e4.png";